export default __webpack_public_path__ + "static/media/4.a5f4527d.webp";